module.exports = __webpack_public_path__ + "c9328ba9abd88d7dfd85691d9b3c8030.svg";